import slugify from "slugify";
import { ChakraLink as Link, ChakraHeading } from "@airhelp/react-ui-components";
import { capitalizedHeading } from "./Heading.styles";
import type { HeadingProps } from "./Heading.d";

const Heading = (props: HeadingProps) => {
  const { text, variant } = props;

  const linkId = slugify(text, { lower: true, strict: true });

  const isCapitalizedHeading = variant === "capitals";

  const headingProps = isCapitalizedHeading ? { ...props, ...capitalizedHeading } : { ...props };

  return (
    <>
      <Link id={linkId} display="block" visibility="hidden" pos="relative" top={-24} />
      <ChakraHeading {...headingProps}>{text}</ChakraHeading>
    </>
  );
};

export default Heading;
